export default "__VITE_ASSET__f9ea275c__"